import { render } from "./GroupStats.vue?vue&type=template&id=74a80aa0"
import script from "./js/groupStats.js?vue&type=script&lang=js&external"
export * from "./js/groupStats.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__